module.exports = __webpack_public_path__ + "assets/img/about_code.187f4ea8.png";